import React, { useState } from 'react';

interface SettingsProps {
  show: boolean;
  onClose: () => void;
  onSave: (settings: { numDocs: number | undefined; returnAllSources: boolean }) => void;
  onLogout: () => void;
  initialNumDocs: number | undefined;
  initialReturnAllSources: boolean;
  isLoggedIn: boolean;
}

const DEFAULT_NUM_DOCS = 3;

const Settings: React.FC<SettingsProps> = ({
  show,
  onClose,
  onSave,
  onLogout,
  initialNumDocs,
  initialReturnAllSources,
  isLoggedIn,
}) => {
  const [tempNumDocs, setTempNumDocs] = useState<number | undefined>(initialNumDocs);
  const [isNumDocsFocused, setIsNumDocsFocused] = useState(false);
  const [tempReturnAllSources, setTempReturnAllSources] = useState<boolean>(initialReturnAllSources);

  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-content" 
        style={{ maxWidth: '500px', width: '90%', position: 'relative' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button 
          onClick={onClose}
          style={{ 
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#666',
            width: '2rem',
            height: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
        >
          ×
        </button>
        <h2>Settings</h2>
        {/* Settings Section */}
        <div style={{ 
          padding: '1rem', 
          borderBottom: '2px solid #e0e0e0',
          marginBottom: '1rem'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="numDocs" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
              Number of documents for RAG context:
            </label>
            <small style={{ color: '#666', fontSize: '0.8rem', display: 'block', marginTop: '0.5rem', marginBottom: '0.5rem' }}>
              More documents means better answers, but slower response times.
            </small>
            <input
              id="numDocs"
              type="number"
              min="1"
              max="20"
              value={isNumDocsFocused ? (tempNumDocs || '') : (tempNumDocs || DEFAULT_NUM_DOCS)}
              onChange={(e) => {
                const value = e.target.value;
                setTempNumDocs(value === '' ? undefined : parseInt(value) || 1);
              }}
              onFocus={() => setIsNumDocsFocused(true)}
              onBlur={() => setIsNumDocsFocused(false)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
            />
          </div>
          {/* Add checkbox for return all sources if logged in */}
          {isLoggedIn && (
            <div style={{ marginBottom: '1rem' }}>
              <label htmlFor="returnAllSources" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
                <input
                  id="returnAllSources"
                  type="checkbox"
                  checked={tempReturnAllSources}
                  onChange={(e) => setTempReturnAllSources(e.target.checked)}
                  style={{ marginRight: '0.5em' }}
                />
                Return all sources
              </label>
              <small style={{ color: '#666', fontSize: '0.8rem', display: 'block', marginTop: '0.5rem' }}>
                Slower, but useful for debugging.
              </small>
            </div>
          )}
          <div style={{ textAlign: 'right' }}>
            <button 
              className="modal-button submit" 
              onClick={() => onSave({ numDocs: tempNumDocs, returnAllSources: tempReturnAllSources })}
              style={{ 
                backgroundColor: '#007bff', 
                color: 'white', 
                border: 'none', 
                padding: '0.75rem 1.5rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Save Settings
            </button>
          </div>
        </div>
        {/* Logout Section */}
        <div style={{ padding: '1rem' }}>
          <h3 style={{ margin: '0 0 1rem 0', color: '#d32f2f', fontSize: '1.1rem' }}>
            Session Management
          </h3>
          <p style={{ margin: '0 0 1rem 0', color: '#666', fontSize: '0.9rem' }}>
            Log out of your account to end your session.
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button 
              className="modal-button logout" 
              onClick={onLogout}
              style={{ 
                backgroundColor: '#d32f2f', 
                color: 'white', 
                border: 'none', 
                padding: '0.75rem 1.5rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 